import * as z from "zod";
import { commerceCloudApiKind } from "./get-commerce-cloud-setup";

export const verifyCommerceCloudAccess = {
  name: "verifyCommerceCloudAccess" as const,
  input: z.object({ api: commerceCloudApiKind }),
  output: z.object({ ok: z.boolean(), error: z.string().nullish() }),
};
